import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import logo from "../logo.png"
import IdleTimeOutHandler from './idleTimeContainer';
import axios from "../axiosInstance";
import { useCookies } from 'react-cookie';
import { postUserLog } from '../hooks/UserLogs';
export default function Sidebar() {
    const OpSidebar=()=>{
const body=document.querySelector("body"),
sidebar=body.querySelector(".sidebar"),
toggle=body.querySelector(".toggle"),
searchBtn=body.querySelector(".search-box"),
modeSwitch=body.querySelector(".toggle-switch"),
modeText=body.querySelector(".mode-text");

if(toggle!=null){
toggle.addEventListener("click",()=>{
    sidebar.classList.toggle("close")
});
}
if(modeSwitch!=null){
modeSwitch.addEventListener("click",()=>{
    body.classList.toggle("dark")
    if(body.classList.contains("dark")){
        modeText.innerHTML="Light Mode"
    }else{
        modeText.innerHTML="Dark Mode"
    }
})
}
if(searchBtn!=null){
searchBtn.addEventListener("click",()=>{
    sidebar.classList.remove("close")
})
}
    }
const [cookies,setCookies]=useCookies(['cookieConsent']);
const axiosInstance = axios.create({
      withCredentials: true,
    })
    
const burl = process.env.REACT_APP_B_URL

    const [isActive,setIsActive]=useState(true);
    const navigate = useNavigate();
    const logOut=async()=>{
        await axiosInstance.get(burl+"/agent-owner/logout").catch(
            rsp=>{
                console.log(rsp)
            }
        ).then(err=>{
            console.error(err)
        })
        await postUserLog(burl+"/userLogs/addUserLogs",'Déconnecxion','');
        sessionStorage.removeItem('name','');
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('idUser');
        
        document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        if(cookies.cookieConsent) {
            setCookies('token', '',{path: '/'})
           }
        
        
        navigate("/backoffice/login");
    }

    return (
        <>
            <nav className="sidebar close">
        <header>
            <div className="image-text">
                <span className="image">
                    <img src={logo} alt="img" width="150%"className='logo'/>
                </span>
                <div className=" text header-text">
                    <span className="name">Univer des solutuions numeriques</span>
                    <span className="prfession">Web Developper</span>

                    
                </div>
            </div>
            <i className='bx bx-chevron-right toggle' onClick={OpSidebar}></i>
        </header>
        <div className="menu-bar">
            <div className="menu">
                <ul className="menu-link">
                    <li className="search-box" onClick={OpSidebar}>
                     
                            <i className='bx bx-search icon'></i>
                            <input type="text" placeholder="Search..." className="text"/>
                     
                    </li>
                    <li className={window.location.pathname=='/home'?"open nav-link-my":"nav-link-my" }>
                    <Link  to="/home">
                    <i className='bx bx-home-alt icon' onClick={OpSidebar}></i>
                            <span className="text nav-text">Dashboard</span>
                        </Link>
                    </li>
                    <li className={window.location.pathname=='/invoices'?"open nav-link-my drop-container":"nav-link-my drop-container" }>
                    <Link  to="/invoices">
                    <i className='bx bx-receipt icon' onClick={OpSidebar}></i>
                            <span className="text nav-text">Transactions</span>
                        </Link>
                    
                        
                    </li>
                   
                    <li className={window.location.pathname=='/agents'?"open nav-link-my drop-container":"nav-link-my drop-container" }>
                    <Link  to="/agents">
                    <i className='bx bx-user-check icon' onClick={OpSidebar} ></i>
                            <span className="text nav-text">Marchand</span>
                        </Link>
                    
                        
                    </li>
                    <li className={window.location.pathname=='/customers'?"open nav-link-my drop-container":"nav-link-my drop-container" }>
                    <Link  to="/customers">
                    <i className='bx bx-group icon' onClick={OpSidebar}></i>
                            <span className="text nav-text">Clients</span>
                        </Link>
                    
                        
                    </li>

                    <li className={window.location.pathname=='/staff'?"open nav-link-my":"nav-link-my" }>
                        <Link  to="/staff">
                        <i className='bx bxs-user-account icon' onClick={OpSidebar}></i>
                            <span className="text nav-text">Staff</span>
                       </Link>
                    </li>
                   
                    <li className={window.location.pathname=='/agencies'?"open nav-link-my":"nav-link-my" }>
                        <Link  to="/agencies">
                        <i className='bx bx-wallet icon' onClick={OpSidebar}></i>
                            <span className="text nav-text">Agence</span>
                       </Link>
                    </li>
                    <li className={window.location.pathname=='/limit-per-payment-methods'?"open nav-link-my":"nav-link-my" }>
                        <Link  to="/limit-per-payment-methods">
                        <i className='bx bxs-arrow-to-bottom icon' onClick={OpSidebar}></i>
                            <span className="text nav-text icon">Limites</span>
                       </Link>
                    </li>
                    <li className={window.location.pathname=='/system-logs'?"open nav-link-my":"nav-link-my" }>
                        <Link  to="/system-logs">
                        <i className='bx bx-server icon' onClick={OpSidebar}></i>
                            <span className="text nav-text">Fichiers journaux</span>
                       </Link>
                    </li>
                    <li className={window.location.pathname=='/api-group' || window.location.pathname.startsWith('/api-records')?"open nav-link-my":"nav-link-my" }>
                        <Link  to="/api-group">
                        <i className='bx bx-bar-chart-alt-2 icon' onClick={OpSidebar}></i>
                            <span className="text nav-text">Statistiques API</span>
                       </Link>
                    </li> 

                </ul>
            </div>
            <div className="bottom-content">
                <li className="">
                    <a href="#"  onClick={()=>logOut()}>
                        <i className='bx bx-log-out icon'></i>
                        <span className="text nav-text">Logout</span>
                    </a>
                </li>
                <li className="mode">
                <div className="moon-sun">
                    <a href="#">
                        <i className='bx bx-moon icon moon'></i>
                        <i className='bx bx-sun icon sun'></i>
                    </a>
                </div>
                <span className="mode-text text">Dark Mode</span>
                <div className="toggle-switch" onClick={()=>OpSidebar()}>
                        <span className="switch"></span>
                </div>
            </li>
            </div>
        </div>
        
        
    </nav>
    <IdleTimeOutHandler onIdle={()=>{logOut()}} onActive={()=>setIsActive(true)} ></IdleTimeOutHandler>

        </>
    )
}
